module.exports = __webpack_public_path__ + "img/monitor.7c40c9df.svg";